<form [formGroup]="form">
  <div class="filter-container d-flex flex-wrap" *ngIf="!isLoading">
    <label *ngIf="isAdmin">
      Cities
      <div class="chip btn-group" mdbDropdown>
        <div mdbDropdownToggle>
          {{ form.controls.city.value }}
          <mdb-icon fas icon="chevron-down" class="close"></mdb-icon>
        </div>

        <div class="dropdown-menu dropdown-primary">
          <a class="dropdown-item" (click)="resetCity()">All</a>
          <div class="divider dropdown-divider"></div>
          <div
            class="dropdown-item"
            *ngFor="let city of cities"
            (click)="changeCity(city)"
          >
            {{ city.city_name + ", " + city.state }}
          </div>
        </div>
      </div>
    </label>
    <label *ngIf="isAdmin" [ngClass]="{ disabled: allCities }">
      Venues
      <div
        class="chip btn-group"
        mdbDropdown
        [ngClass]="{ disabled: allCities }"
      >
        <div mdbDropdownToggle>
          {{ form.controls.venue.value }}
          <mdb-icon fas icon="chevron-down" class="close"></mdb-icon>
        </div>
        <div class="dropdown-menu dropdown-primary">
          <a class="dropdown-item" (click)="resetVenue()">All</a>
          <div class="divider dropdown-divider"></div>
          <a
            class="dropdown-item"
            *ngFor="let venue of venues"
            (click)="changeVenue(venue)"
            >{{ venue.name }}</a
          >
        </div>
      </div>
    </label>
    <label>
      Timeframe
      <div class="chip btn-group" mdbDropdown>
        <div mdbDropdownToggle>
          {{ form.controls.timeframe.value }}
          <mdb-icon fas icon="chevron-down" class="close"></mdb-icon>
        </div>
        <div class="dropdown-menu dropdown-primary">
          <a
            class="dropdown-item"
            *ngFor="let tf of objectKeys(timeframes)"
            (click)="changeTimeframe(tf)"
            >{{ tf }}</a
          >
        </div>
      </div>
    </label>
    <label>
      Product Type
      <div class="chip btn-group" mdbDropdown>
        <div mdbDropdownToggle>
          {{ form.controls.productType.value }}
          <mdb-icon fas icon="chevron-down" class="close"></mdb-icon>
        </div>
        <div class="dropdown-menu dropdown-primary">
          <a class="dropdown-item" (click)="resetType()">All</a>
          <div class="divider dropdown-divider"></div>
          <a
            class="dropdown-item"
            *ngFor="let type of types"
            (click)="changeType(type)"
            >{{ type }}</a
          >
        </div>
      </div>
    </label>
    <label>
      Redeemed
      <div
        class="chip toggle"
        [ngClass]="{ active: showRedeemed }"
        (click)="changeRedeemed(!showRedeemed)"
      >
        Yes
        <mdb-icon fas icon="times" *ngIf="showRedeemed"></mdb-icon>
        <mdb-icon fas icon="plus" *ngIf="!showRedeemed"></mdb-icon>
      </div>
      <div
        class="chip toggle"
        [ngClass]="{ active: showOutstanding }"
        (click)="changeOutstanding(!showOutstanding)"
      >
        No
        <mdb-icon fas icon="times" *ngIf="showOutstanding"></mdb-icon>
        <mdb-icon fas icon="plus" *ngIf="!showOutstanding"></mdb-icon>
      </div>
    </label>
  </div>
  <div class="filter-container" *ngIf="isLoading">
    <div class="spinner-grow justify-self-center" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</form>
